import axios from 'axios';
import { getErrorMessage, handleApiError } from '../utils/errorHandler';
import API_BASE_URL from '../config/api';

const BASE_URL = `${API_BASE_URL}/steel-testing`;

export const createSteelTest = async (testData) => {
  const url = `${BASE_URL}/tests`;
  try {
    const response = await axios.post(url, testData);
    return response.data;
  } catch (error) {
    const status = error.response?.status;
    const data = error.response?.data;
    const isNetworkError = !error.response && (error.message === 'Network Error' || error.code === 'ERR_NETWORK');
    let detail = 'Failed to save steel test. Please try again.';
    if (isNetworkError) {
      detail = 'Cannot connect to the backend. Start the backend server (e.g. run START_BACKEND.bat in the backend folder or: python app.py) and ensure it is running on http://localhost:5001';
    } else if (data) {
      if (typeof data.error === 'string') detail = data.error;
      else if (typeof data.detail === 'string') detail = data.detail;
      else if (data.message) detail = typeof data.message === 'string' ? data.message : JSON.stringify(data.message);
      else if (typeof data === 'string') detail = data;
    } else if (error.message) {
      detail = error.message;
    }
    console.error('Steel Testing API Error: status=', status ?? 'none', 'url=', url, 'message=', error.message, 'data=', error.response?.data != null ? JSON.stringify(error.response.data) : 'none');
    if (status === 404) {
      handleApiError(error, 'Steel testing save endpoint not found (404). Ensure the backend is running and steel_testing_api is registered.');
    } else {
      handleApiError(error, detail);
    }
    throw error;
  }
};

export const getAllSteelTests = async () => {
  const url = `${BASE_URL}/tests`;
  try {
    const response = await axios.get(url);
    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    if (error.response?.status === 404) return [];
    throw error;
  }
};

export const getSteelTest = async (id) => {
  const url = `${BASE_URL}/tests/${id}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) return null;
    throw error;
  }
};
